import getProjectCredits from './api/getProjectCredits';
import getUserCredits from './api/getUserCredits';
import isProUser from './isProUser';

export type CreditCheckResult =
  | { sufficient: true; projectCredits: number }
  | { sufficient: false; reason: 'fetch-failed' }
  | {
      sufficient: false;
      reason: 'insufficient';
      projectCredits: number;
      isPro: boolean;
    };

/**
 * Pure orchestration — no UI side effects. Resolves the question "does this
 * user have enough credits to run the flow?". Callers decide UX (toast,
 * offer modal, retry).
 */
const ensureSufficientCredits = async ({
  flowId,
}: {
  flowId: string;
}): Promise<CreditCheckResult> => {
  const projectCredits = await getProjectCredits({ webhookId: flowId });
  if (projectCredits === null) {
    return { sufficient: false, reason: 'fetch-failed' };
  }

  const userCredits = await getUserCredits();
  if (userCredits >= projectCredits) {
    return { sufficient: true, projectCredits };
  }

  const isPro = await isProUser();
  return {
    sufficient: false,
    reason: 'insufficient',
    projectCredits,
    isPro,
  };
};

export default ensureSufficientCredits;
